<template>
  <div class="mine">
    <div class="mine-header" :style="{'background-image': 'url('+ mineImg +')'}">
        <div class="mineAvatarBox flex flex-j-c-center">
            <img :src="pageData.avatar_url" class="mine-avatar">
            <p>{{pageData.true_name || pageData.nickname || '-'}}</p>
            <span v-if="pageData.first_name && pageData.goods_name">{{pageData.first_name}} | {{pageData.goods_name}}</span>
        </div>
        <img src="@/assets/mine/my_icon_install@3x.png" class="mine-setting" v-if="pageData.is_pay == 1" @click="toPath({'path':'/Personal'})">
    </div>
    <div class="mine-context">
        <!-- <mt-cell title="标题文字" is-link>
            <span>我的信息</span>
            <img slot="icon" src="@/assets/mine/my_icon_pdate@3x.png" width="15" height="15">
        </mt-cell> -->
            <div class="per-line" v-if="pageData.is_pay == 1" @click="toPath({'path':'/Personal'})">
                <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/mine/my_icon_pdate@3x.png" class="mineFunc-icon"/>
                        <span class="mineFunc-text">我的信息</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 课表 -->
            <!-- <div class="per-line" v-if="pageData.is_pay == 1" @click="toPath('course')">
                <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/mine/my_icon_Timetable@3x.png" class="mineFunc-icon"/>
                        <span class="mineFunc-text">在线课程</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div> -->
            <!-- 我的课程 -->
            <van-collapse v-model="activeName" accordion v-if="pageData.is_pay == 1">
                <van-collapse-item name="1">
                    <template #title>
                        <div class="mine-func flex flex-a-i-center">
                            <img src="@/assets/mine/my_icon_Timetable@3x.png" class="mineFunc-icon"/>
                            <span class="mineFunc-text">我的课程</span>
                        </div>
                    </template>

			<!--     <div class="per-line" @click="toPath('course-old')">
                        <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                            <div class="flex flex-a-i-center flex-j-c-center">
                                <span class="mineFunc-text">教材精讲班</span>
                            </div>
                            <div class="flex flex-j-c-e method-right flex-a-i-center">
                                <img class="right-icon" src="@/assets/right.png">
                            </div>
                        </div>
                    </div>
					-->

                    <div class="per-line" @click="toPath('course-new')">
                        <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                            <div class="flex flex-a-i-center flex-j-c-center">
                                <span class="mineFunc-text">考前辅导课</span>
                            </div>
                            <div class="flex flex-j-c-e method-right flex-a-i-center">
                                <img class="right-icon" src="@/assets/right.png">
                            </div>
                        </div>
                    </div>
                </van-collapse-item>
            </van-collapse>
            <!-- 订单 -->
            <div class="per-line" @click="toPath({'path':'/Order'})">
                <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/mine/my_icon_order@3x.png" class="mineFunc-icon"/>
                        <span class="mineFunc-text">我的订单</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 我的地址 -->
            <div class="per-line" v-if="pageData.is_pay == 1" @click="toPath({'path':'/Address'})">
                <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/mine/address.png" class="mineFunc-icon"/>
                        <span class="mineFunc-text">我的地址</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 我的班主任 -->
            <div class="per-line" v-if="pageData.is_pay == 1" @click="toPath({'path':'/Teacher'})">
                <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/mine/teach.png" class="mineFunc-icon"/>
                        <span class="mineFunc-text">我的班主任</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>

        <!-- 优惠券 -->
		<!--
        <div class="per-line" @click="toPath({'path':'/Coupon?type=mine'})">
            <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                <div class="flex flex-a-i-center flex-j-c-center">
                    <img src="@/assets/mine/my_icon_Coupon@3x.png" class="mineFunc-icon"/>
                    <span class="mineFunc-text">我的优惠券</span>
                </div>
                <div class="flex flex-j-c-e method-right flex-a-i-center">
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
		-->
    </div>
    <div class="mine-about" style="margin-top:0.1rem;">
        <div class="per-line" @click="toNotice">
            <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                <div class="flex flex-a-i-center flex-j-c-center">
                    <img src="@/assets/mine/my_icon_about@3x.png" class="mineFunc-icon"/>
                    <span class="mineFunc-text">关于陈文卫</span>
                </div>
                <div class="flex flex-j-c-e method-right flex-a-i-center">
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
        <div class="per-line" @click="refreshLogin">
            <div class="mine-func flex flex-j-c-sb flex-a-i-center">
                <div class="flex flex-a-i-center flex-j-c-center">
                    <img src="@/assets/mine/my_icon_about@3x.png" class="mineFunc-icon"/>
                    <span class="mineFunc-text">刷新登录</span>
                </div>
                <div class="flex flex-j-c-e method-right flex-a-i-center">
                    <img class="right-icon" src="@/assets/right.png">
                </div>
            </div>
        </div>
    </div>
    <Footer vals="tabMine" :vtext.sync="vtext"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue';
import {getUserInfo, FuserMsg} from '@/api';
import { Toast } from 'mint-ui';

export default {
  name: 'Mine',
  components: {
    Footer,
  },
  data() {
    return {
      mineImg: require('@/assets/mine/my_bg01@3x.png'), // 头像背景
      pageData: {avatar_url: require('@/assets/avatar.png'),}, // 页面数据
      sessionData: {}, // 临时数据 存储页面信息
      vtext: '0元上大学', // 学员&教师 底部 bar 显示文字
      activeName: ''
    }
  },
  created() {
    this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
    if (this.sessionData && this.sessionData.MineIndex) this.pageData = JSON.parse(this.sessionData.MineIndex);
  },
  mounted () {
    this.userInfo();
  },
  methods: {
    /**
     * 页面跳转
     * e 跳转目标页面
     */
    toPath(e) {
        // if (e === 'course') {
        //     // {'path':'/Course'}
        //     let pdata = JSON.parse(sessionStorage.getItem('_userType'));
        //     if (this.pageData.second_name === "高升专" || this.pageData.second_name === "高升本") {
        //         // window.location.href = `https://wx8e3ca81b18268efc.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVkYTAxYzRkNzhhMzlfOWZWeDFGek8iLCJhcHBfaWQiOiJhcHBCanNEazhvYzg0MzcifQ`
        //         window.location.href = `https://appBjsDk8oc8437.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVkYTAxYzRkNzhhMzlfOWZWeDFGek8iLCJhcHBfaWQiOiJhcHBCanNEazhvYzg0MzcifQ`
        //     } else {
        //         // window.location.href = `https://wx8e3ca81b18268efc.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVkYTAxYmU4OTgxZDBfSmRXUFZVamEiLCJhcHBfaWQiOiJhcHBCanNEazhvYzg0MzcifQ`
        //         window.location.href = `https://appBjsDk8oc8437.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVkYTAxYmU4OTgxZDBfSmRXUFZVamEiLCJhcHBfaWQiOiJhcHBCanNEazhvYzg0MzcifQ`
        //     }
        // } else {
        //     this.$router.push(e)
        // }
        let pdata = JSON.parse(sessionStorage.getItem('_userType'));
        switch (e) {
            case 'course-old': // 旧版：《教材精讲班》考前辅导课
                if (this.pageData.second_name === "高升专" || this.pageData.second_name === "高升本") {
                    // 旧版：《教材精讲班》 高升专/本
                    window.location.href = `https://appBjsDk8oc8437.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzYwZDQyN2U3ZTRiMGVkMDlhZWRmYjc2MSIsImFwcF9pZCI6ImFwcEJqc0RrOG9jODQzNyJ9`
                } else {
                    // 旧版：《教材精讲班》 专升本
                    window.location.href = `https://appBjsDk8oc8437.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzYwZDQyYWFkZTRiMDI3MGEwZmVmZmI2NyIsImFwcF9pZCI6ImFwcEJqc0RrOG9jODQzNyJ9`
                }
                break;
            case 'course-new': // 新版：《考前冲剌班》考前辅导课
                if (this.pageData.second_name === "高升专" || this.pageData.second_name === "高升本") {
                    // 新版：《考前冲剌班》 高升专/本
                    window.location.href = `https://wx8e3ca81b18268efc.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVmMTRmMmIyZTRiMGFlYmNhNjFhMDY1NyIsImFwcF9pZCI6ImFwcEJqc0RrOG9jODQzNyJ9`
                } else {
                    // 新版：《考前冲剌班》 专升本
                    window.location.href = `https://wx8e3ca81b18268efc.h5.xiaoe-tech.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVmMTRmMzgwZTRiMGQ3Mzg5NmIzOGQyOCIsImFwcF9pZCI6ImFwcEJqc0RrOG9jODQzNyJ9`
                }
                break;
            case 'course': // 在线课程
                if (this.pageData.second_name === "高升专" || this.pageData.second_name === "高升本") {
                    window.location.href = `https://appBjsDk8oc8437.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVkYTAxYzRkNzhhMzlfOWZWeDFGek8iLCJhcHBfaWQiOiJhcHBCanNEazhvYzg0MzcifQ`
                } else {
                    window.location.href = `https://appBjsDk8oc8437.h5.xiaoeknow.com/content_page/eyJ0eXBlIjozLCJyZXNvdXJjZV90eXBlIjo4LCJyZXNvdXJjZV9pZCI6IiIsInByb2R1Y3RfaWQiOiJwXzVkYTAxYmU4OTgxZDBfSmRXUFZVamEiLCJhcHBfaWQiOiJhcHBCanNEazhvYzg0MzcifQ`
                }
                break;
            default:
                this.$router.push(e)
                break;
        }
    },
    // 人人招生页数据获取
    getUserMsg() {
        FuserMsg().then(res => {
           this._tools.checkSData(res.data, 'RecruitIndex')
           this.vtext = res.data.level == 1 ? '推荐有礼' : res.data.level == 2 ? '合伙人计划' : '0元上大学'
        })
    },
    // 用户信息获取
    userInfo() {
      getUserInfo().then(res => {
        this.pageData = res.data
        if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 1500}); }
        else {
          sessionStorage.setItem('_userType', JSON.stringify(res.data));
          if (!this._tools.checkSData(res.data, 'MineIndex')) {
            this.pageData = res.data;
          }
          this.getUserMsg();
        }
      })
    },
    // 跳转 关于陈文卫 文章
    toNotice() {
      let uid = JSON.parse(localStorage.getItem('cww_data')).id;
      window.location.href = `${window.location.origin}/NoticeDetail?id=9&invitorId=${uid}`;
    },
    //刷新登录
    refreshLogin() {
        localStorage.setItem('cww_data', false);
        window.location.href = `${window.location.origin}/Mine`;
    }
  },
  watch: {
  }
};
</script>

<style lang="less" scoped>
  .mine{
    min-height: 100vh;
    height:100%;
    .mine-header{
        width: 100%;
        height: 1.65rem;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        .mineAvatarBox{
            position: absolute;
            top: 0.3rem;
            left: 50%;
            transform: translateX(-50%);
            flex-direction: column;
            .mine-avatar{
                width: 0.62rem;
                height: 0.62rem;
                margin: 0 auto 0.12rem;
                border-radius: 50%;
                border: 2px solid white;
            }
            p{
                font-size: 0.17rem;
                font-weight: bold;
            }
            span{
                font-size: 0.12rem;
                margin-top: 0.06rem;
            }
        }
        .mine-setting{
            width: 0.16rem;
            height: 0.16rem;
            position: absolute;
            right: 0.16rem;
            top: 0.3rem;
        }
    }
    .mine-context,.mine-about{
        margin-top: 0.2rem;
        padding: 0 0.16rem;
        background: white;
        &>:last-child{
            border: none;
        }
        .mine-func{
            background: white;
            .mineFunc-icon{
                width: 0.15rem;
                height: 0.15rem;
                margin-right: 0.08rem;
            }
            .mineFunc-text{
                font-size: 0.15rem;
                color: #333333;
            }
        }
    }
    .mine-about{
        margin-bottom: 0.6rem;
    }
  }
  /deep/ .van-cell {
      padding: 10px 0;
  }
</style>
